var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOzEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#paint0_linear_1424_2673)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0624 3V8.17525L14.4365 10.1298L10.0624 3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0622 3L5.68744 10.1298L10.0622 8.17525V3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0624 13.4835V17L14.4394 10.9443L10.0624 13.4835Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0622 17V13.4829L5.6875 10.9443L10.0622 17Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0624 12.6696L14.4365 10.1298L10.0624 8.17646V12.6696Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 10.1298L10.0622 12.6696V8.17646L5.6875 10.1298Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1424_2673",
    x1: 0,
    y1: 10.0023,
    x2: 20,
    y2: 10.0023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA742B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOzEth);
export default __webpack_public_path__ + "static/media/ozETH.f9a60a24d758e3b57c66ef083f879fd7.svg";
export { ForwardRef as ReactComponent };